import React from 'react';
import { Typography } from '@material-ui/core';
function SpecialtiesProfileComponent(props) {
  const { provider } = props;
  return (
    (provider.specialties &&
      provider.specialties
      .sort((a, b) => a.name.localeCompare(b.name))  
      .map(item => {
        return (
          <Typography>
            <span>{item.name}</span>
          </Typography>
        );
      })) ||
    null
  );
}

export default SpecialtiesProfileComponent;
